import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    hasError: Boolean
  }

  connect() {
    if (!this.hasErrorValue) {
      document.dispatchEvent(new CustomEvent('hide-modal'))
    }
  }
}
